import { render, staticRenderFns } from "./Mecanicos.vue?vue&type=template&id=66e9b6b6&scoped=true"
import script from "./Mecanicos.vue?vue&type=script&lang=js"
export * from "./Mecanicos.vue?vue&type=script&lang=js"
import style0 from "./Mecanicos.vue?vue&type=style&index=0&id=66e9b6b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e9b6b6",
  null
  
)

export default component.exports